import { useState, useCallback } from 'react'
import { usePage, router } from '@inertiajs/react'
import { useTranslation } from '@/hooks/useTranslation'

export function useSiteNavbarVM() {
  const { url } = usePage()
  const { t, locale, locales, lp, localePath } = useTranslation()
  const [mobileOpen, setMobileOpen] = useState(false)

  const navItems = [
    { label: t('nav.services'), href: lp('/#servizi') },
    { label: t('nav.workflow'), href: lp('/#workflow') },
    { label: t('nav.about'), href: lp('/#about') },
    { label: t('nav.blog'), href: lp('/blog') },
  ]

  const toggleMobile = useCallback(() => {
    setMobileOpen((prev) => !prev)
  }, [])

  const closeMobile = useCallback(() => {
    setMobileOpen(false)
  }, [])

  const switchLocale = useCallback((targetLocale: string) => {
    // Strip current locale prefix from the URL to get the base path
    const localePattern = /^\/(en|it)(\/|$)/
    let basePath = url.replace(localePattern, '/')
    if (!basePath.startsWith('/')) basePath = '/' + basePath

    const newPath = localePath(basePath, targetLocale)
    router.visit(newPath)
  }, [url, localePath])

  return {
    navItems,
    currentPath: url,
    mobileOpen,
    toggleMobile,
    closeMobile,
    locale,
    locales,
    switchLocale,
    t,
    lp,
  }
}
